import { CoreActions } from "../actions";
import { TYPES } from "../actions/core.actions";
import { Category } from "src/app/routes/catalog/models/category.model";
import { Product } from "src/app/routes/catalog/models/product.model";
import { Page } from "../../models/page.model";
import { Screen } from "../../models/screen.model";

export interface State {
  sideMenuOpened: boolean;
  screen: Screen;
  breadcrumb?: Category | Product | Page | null;
  scrollPosition: number;
}

export const initialState: State = {
  sideMenuOpened: false,
  screen: {
    mobile: false,
    tablet: false,
    desktop: false,
  },
  breadcrumb: {
    label: "Accueil",
    slug: "",
    entity: "page",
  },
  scrollPosition: 0,
};

export function reducer(
  state: State = initialState,
  action: CoreActions.Union,
): State {
  switch (action.type) {
    case TYPES.SET_SCREEN:
      return {
        ...state,
        screen: action.screen,
      };

    case TYPES.SET_BREADCRUMB:
      return {
        ...state,
        breadcrumb: action.breadcrumb,
      };

    case TYPES.SET_SCROLLPOSITION:
      return {
        ...state,
        scrollPosition: action.scrollPosition,
      };
    default:
      return state;
  }
}
